import { eventDefaultColor } from "@app/core";

import { EntityColorControl } from "../../../features/organize/index.js";
import { useI18n } from "../../../lib/useI18n.js";
import { useThemeStore, type EntityTarget } from "../../../stores/index.js";

/** The broad levels of the entity-color hierarchy: everything → tasks → events.
 *  Per-topic / per-calendar / per-label colors live on Settings → Topics,
 *  Labels and Calendars now;
 *  more-specific always wins at render time. Each row arms the palette board. */
export function EntityDefaultsEditor() {
  const { t } = useI18n();
  const config = useThemeStore((s) => s.config);
  const setEntityColor = useThemeStore((s) => s.setEntityColor);
  const entity = config.entity;

  const rows: { label: string; target: EntityTarget; value: string; overridden: boolean }[] = [
    {
      label: t("theme.entity.global"),
      target: { kind: "global" },
      value: entity.global ?? "#888888",
      overridden: !!entity.global,
    },
    {
      label: t("theme.entity.task"),
      target: { kind: "taskKind", isEvent: false },
      value: entity.kind?.task ?? entity.global ?? "#888888",
      overridden: !!entity.kind?.task,
    },
    {
      label: t("theme.entity.event"),
      target: { kind: "taskKind", isEvent: true },
      value: entity.kind?.event ?? entity.global ?? eventDefaultColor(config),
      overridden: !!entity.kind?.event,
    },
  ];

  return (
    <div className="flex flex-col gap-1.5">
      {rows.map((row) => (
        <div key={row.label} className="flex items-center gap-3 text-sm">
          <span className="w-28 shrink-0 truncate">{row.label}</span>
          <EntityColorControl
            targetRef={{ kind: "entity", target: row.target }}
            value={row.value}
            overridden={row.overridden}
            onRevert={() => setEntityColor(row.target, null)}
            boardAnchorId="theme-board"
          />
        </div>
      ))}
    </div>
  );
}
